import React from 'react';
import {
  GridTable
} from '@ctsu/ctsu-mui-grid';
import { getSessionByKey, GetUserFullName, useGetPathProtocol } from 'helpers';
import PropTypes from 'prop-types';
import { TE } from 'appconstants';
import { ParticipationInformationColumns } from '../gridcolumns';

const InstPartInfo = ({
  protocolNumber, getToken
}) => (
  <GridTable
    tag={`${TE.ID}parrticipationinfo${TE.TABLE}`}
    title="Participation Information"
    exportTitle={`Participation Information-${useGetPathProtocol()}-Participation`}
    remoteUrl={`protocol-data-service/${
      getSessionByKey('prt_url_ver')
    }/protocols/number/${protocolNumber}/cirbsiteparticipants`}
    columns={ParticipationInformationColumns}
    user={GetUserFullName()}
    enableToolbar
    defaultSorts={[{
      field: 'siteCtepId',
      dir: 'asc'
    }]}
    getToken={getToken}
    filterable
    sortable
    recordPerPage={10}
    toPdf={false}
  />
);

InstPartInfo.propTypes = {
  protocolNumber: PropTypes.string.isRequired,
  getToken: PropTypes.func.isRequired
};

export { InstPartInfo };
